import { FaSearch } from "react-icons/fa";
import { sanitizeInput } from "src/helpers/sanitizeInput";
import { IoCloseOutline } from "react-icons/io5";
import "./search.scss";

type SearchProps = {
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
};

export default function Search({
    value,
    onChange,
    placeholder = "Search",
}: SearchProps) {
    return (
        <div className={`search${value ? " search--active" : ""}`}>
            <FaSearch className="search-icon" />

            <input
                id="search"
                name="search"
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange(sanitizeInput(e.target.value))}
            />

            {value && (
                <IoCloseOutline
                    className="search-clear"
                    onClick={() => onChange("")}
                />
            )}
        </div>
    );
}
